<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <!-- 로딩 스피너 -->
        <loading-spinner v-if="isLoading"></loading-spinner>

        <paginated-table
          v-else
          :data="journals"
          :columns="columns"
          :title="$t('title.journal_list')"
          icon="toc"
          @updatePagination="updatePagination"
        >
          <template v-slot:top-buttons>
            
            <custom-button
              class="mr-2"
              @click="goPublishManagement"
              :label="$t('title.journal_publish_management')"
              color="info"
              icon="toc"
              size="lg"
              gradient
              rounded
            ></custom-button>
            
            <custom-button
              @click="add"
              :label="$t('button.add')"
              color="primary"
              icon="add"
              size="lg"
              gradient
              rounded
            ></custom-button>
          </template>
        </paginated-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import { getJournalManagementColumns } from "@/fields/journal/columns";
import { journalApi } from "@/api/api";

export default {
  components: {
    PaginatedTable,
    CustomButton,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      journals: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      columns: getJournalManagementColumns({
        detail: this.showDetail,
        info: this.showInfo,
        edit: this.edit,
      }),
    };
  },
  methods: {
    showDetail(item) {
      this.$router.push(`/journals/detail/${item.idx}`);
    },
    showInfo(item) {
      this.$router.push(`/journals/edit/${item.idx}`);
    },
    edit(item) {
      this.$router.push(`/journals/${item.idx}/contents/edit`);
    },
    goPublishManagement() {
      this.$router.push(`/journals/publish`);
    },
    add() {
      this.$router.push(`/journals/create`);
    },
    updatePagination(pagination) {
      this.journals.page_info.size = pagination.size;
      this.journals.page_info.page = pagination.page;

      this.fetchJournals();
    },

    /* ****************************************************************************************
     * API 호출
     * ****************************************************************************************/
    async fetchJournals() {
      const params = {
        page: this.journals.page_info.page,
        size: this.journals.page_info.size,
        sort_by: "idx",
        direction: "desc",
      };

      try {
        this.isLoading = true;
        const response = await journalApi.showAll(params);
        if (response.status === 200) {
          this.journals = response.data.response;
        }
      } catch (error) {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        this.$router.push({ name: "dashboard" });
      } finally {
        this.isLoading = false;
      }
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchJournals();
  },
};
</script>
